<toolbox-tab-menu></toolbox-tab-menu>
<toolbox-navigation></toolbox-navigation>
<toolbox-steps-menu></toolbox-steps-menu>